module.exports = __webpack_public_path__ + "static/media/pic4.773b6cfb.jpg";